import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class DepletedFieldSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.DEPLETED_FIELD;
}

export default DepletedFieldSalvageableTileEntity;
